export function sumInvoiceValues(invoices) {
  return (invoices || []).reduce(
    (sum, inv) => sum + (parseFloat(inv?.invoice_value) || 0),
    0,
  );
}

export function sumApprovedInvoiceValues(invoices) {
  return (invoices || [])
    .filter((inv) => inv?.l2_approval_status === "approved")
    .reduce((sum, inv) => sum + (parseFloat(inv?.invoice_value) || 0), 0);
}

export function summariseInvoiceTableData(invoices) {
  const all = invoices || [];
  const approved = all.filter(
    (inv) => inv?.l2_approval_status === "approved",
  );
  return {
    totalCount: all.length,
    totalInvoicedValue: sumInvoiceValues(all),
    approvedCount: approved.length,
    approvedInvoiceAmount: sumApprovedInvoiceValues(all),
  };
}
